import styled, { css } from 'styled-components'

export const CategoryContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundColor};

  ${({ viewType }) => viewType === 'list' &&`
    padding: 15px;
    position: sticky;
    z-index: 1;
    top: 0;
    background-color: white;
    border-bottom: 0.55px solid rgba(0,0,0,0.1);
  `}
  

  .swiper-slide{
    width: fit-content !important;
    display: inline-block; 
    margin: 0px 10px;
  }
`
export const CategoryTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    padding: 10px;
    margin-bottom: 10px;
    text-transform: uppercase;
    background-color: #f5f7f9;
`
export const CategoriesWrapper = styled.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  ${({ viewType }) => viewType === 'grid' ? css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    margin-bottom: 65px;

    @media (max-width: 990px) {
      margin-bottom: 0;
    }
  ` : css`
    margin-bottom: 65px;
  `}
  ${({ viewType }) => viewType !== 'grid' && css`
    justify-content: center;
    flex-wrap: wrap;
  `}
`
export const CategoryItem = styled.div`
  border-radius: 30px;
  padding: 6px 15px;
  cursor: pointer;
  display: inline-block;
  transition: 0.3s all;
  ${props => props.active 
    ? css`background-color: #9c5a2e;
          border: none;
          color: white;
          `
    : css`background-color: #edecee;
          border: 1px solid #edecee;
          color: black;
          `
  }
`

export const ProductItem = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  ${({ viewType, active, theme }) => viewType === 'grid' ? css`
    width: 100%;
    padding: 12px;
    border: 1.5px solid ${active ? theme.colors.primaryButtCol : theme.colors.gray};
    border-radius: 12px;
    background-color: ${active ? '#fdf8f5' : theme.colors.backgroundColor};
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;

    &:hover {
      border-color: ${theme.colors.primaryButtCol};
      box-shadow: 0 4px 12px rgba(156, 90, 46, 0.12);
    }
  ` : css`
    width: 60%;
    margin-bottom: 10px;
  `}
`
export const CategoryImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 130px;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
  background-color: #f5f7f9;
  border: 1px solid #ebebeb;
`
export const CategoryImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
`
export const CategoryName = styled.div`
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 2px 0;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.primaryIconCol};
`